import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { baseButtonStyles } from './LytBaseButton';
const StyledDangerButton = styled.button.withConfig({
    shouldForwardProp: (prop) => !['isCompact', 'isIconOnly'].includes(prop),
})`
    ${baseButtonStyles}

    background-color: ${({ theme }) =>
        theme.components.lyt_button.danger.background.default};
    color: ${({ theme }) => theme.components.lyt_button.danger.text.default};

    &:hover {
        background-color: ${({ theme }) =>
            theme.components.lyt_button.danger.background.hover};
        color: ${({ theme }) => theme.components.lyt_button.danger.text.hover};
    }

    &:active {
        background-color: ${({ theme }) =>
            theme.components.lyt_button.danger.background.pressed};
        color: ${({ theme }) =>
            theme.components.lyt_button.danger.text.pressed};
    }

    &:focus-visible {
        background-color: ${({ theme }) =>
            theme.components.lyt_button.danger.background.focus};
        outline: 2px solid
            ${({ theme }) => theme.components.lyt_button.danger.border.focus};
        outline-offset: 1px;
    }

    &:disabled {
        background-color: ${({ theme }) =>
            theme.components.lyt_button.danger.background.disabled};
        color: ${({ theme }) =>
            theme.components.lyt_button.danger.text.disabled}4D;
        cursor: not-allowed;
        /* Target SVG icons inside the button */
        & svg {
            stroke: ${({ theme }) =>
                theme.components.lyt_button.danger.text.disabled}4D;
        }
        & svg line,
        & svg polyline,
        & svg path,
        & svg rect,
        & svg polygon {
            stroke: ${({ theme }) =>
                theme.components.lyt_button.danger.text.disabled}4D;
            fill: ${({ theme }) =>
                theme.components.lyt_button.danger.text.disabled}4D;
        }
    }

    &.lyt-button-selected {
        background-color: ${({ theme }) =>
            theme.components.lyt_button.danger.background.selected};
        color: ${({ theme }) =>
            theme.components.lyt_button.danger.text.selected};

        &:hover {
            background-color: ${({ theme }) =>
                theme.components.lyt_button.danger.background.selected};
            color: ${({ theme }) =>
                theme.components.lyt_button.danger.text.selected};
        }
    }
`;
const LytDangerButton = ({ isCompact = false, ...props }) => {
    return <StyledDangerButton isCompact={isCompact} {...props} />;
};
LytDangerButton.propTypes = {
    isCompact: PropTypes.bool,
    children: PropTypes.node,
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
};
export default LytDangerButton;
